import { gql } from '@apollo/client';
const ADD_MODEL_FOLDER = gql `
  mutation AddModelFolder($name: String, $parentFolderId: ID!) {
    addModelSpecificationFolder(name: $name, parentFolderId: $parentFolderId) {
      modelSpecificationFolder {
        id
        name
        modelSpecificationsCount
        foldersCount
        createdDate
        modifiedDate
        canBeRemoved
      }
    }
  }
`;
export default ADD_MODEL_FOLDER;
